import capitalize from 'lodash/capitalize'
import includes from 'lodash/includes'

// See http://titlecase.com/
const APA_EXCEPTIONS = [
  'a',
  'for',
  'so',
  'an',
  'in',
  'the',
  'and',
  'nor',
  'to',
  'at',
  'of',
  'up',
  'but',
  'on',
  'yet',
  'by',
  'or',
]

/**
 * @function toTitleCase
 *
 * @param  {String} input
 *         The string to evaluate.
 *
 * @return {String} The title case string
 */
export function toTitleCase(input) {
  if (!input || !input.length) {
    return null
  }

  const wordsInTitle = input.trim().split(/\s+/)

  return wordsInTitle
    .map((word, index) => {
      const capitalizedWord = capitalize(word)
      const lowerCaseWord = word.toLowerCase()

      // First or last word should always be capitalized
      if (index === 0 || index === wordsInTitle.length - 1) {
        return capitalizedWord
      }

      // Match word in collection of APA exceptions
      if (includes(APA_EXCEPTIONS, lowerCaseWord)) {
        return lowerCaseWord
      }

      return capitalizedWord
    })
    .join(' ')
}

export { APA_EXCEPTIONS }
